export const SPORTS_COUNTERS_POLLING_INTERVAL = 5000
